"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _react = _interopRequireDefault(require("react"));

var _reactStripeElements = require("react-stripe-elements");

var _semanticUiReact = require("semantic-ui-react");

var _axios = _interopRequireDefault(require("axios"));

var _lodash = _interopRequireDefault(require("lodash"));

var _subscriptionPlans = _interopRequireDefault(require("../data/subscription-plans"));

var _paymentTypes = require("../data/payment-types");

function _createSuper(Derived) {
  return function () {
    var Super = (0, _getPrototypeOf2["default"])(Derived),
        result;

    if (_isNativeReflectConstruct()) {
      var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return (0, _possibleConstructorReturn2["default"])(this, result);
  };
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

var CheckoutForm = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2["default"])(CheckoutForm, _React$Component);

  var _super = _createSuper(CheckoutForm);

  function CheckoutForm(props) {
    var _this;

    (0, _classCallCheck2["default"])(this, CheckoutForm);
    _this = _super.call(this, props);
    _this.state = {
      couponCode: null,
      couponCodeValid: true,
      firstName: null,
      lastName: null,
      address: null,
      city: null,
      state: null,
      zipCode: null,
      email: props.email || null,
      phoneNumber: null,
      submitEnabled: false,
      checkoutLoading: false,
      showErrorMessage: false
    };
    _this.onSubmit = _this.onSubmit.bind((0, _assertThisInitialized2["default"])(_this));
    _this.onCouponChanged = _this.onCouponChanged.bind((0, _assertThisInitialized2["default"])(_this));
    _this.onFirstNameChanged = _this.onFirstNameChanged.bind((0, _assertThisInitialized2["default"])(_this));
    _this.onLastNameChanged = _this.onLastNameChanged.bind((0, _assertThisInitialized2["default"])(_this));
    _this.onAddressChanged = _this.onAddressChanged.bind((0, _assertThisInitialized2["default"])(_this));
    _this.onCityChanged = _this.onCityChanged.bind((0, _assertThisInitialized2["default"])(_this));
    _this.onStateChanged = _this.onStateChanged.bind((0, _assertThisInitialized2["default"])(_this));
    _this.onZipCodeChanged = _this.onZipCodeChanged.bind((0, _assertThisInitialized2["default"])(_this));
    _this.onEmailChanged = _this.onEmailChanged.bind((0, _assertThisInitialized2["default"])(_this));
    _this.onPhoneNumberChanged = _this.onPhoneNumberChanged.bind((0, _assertThisInitialized2["default"])(_this));
    _this.onLoadCompleted = _this.onLoadCompleted.bind((0, _assertThisInitialized2["default"])(_this));
    _this.checkInputs = _this.checkInputs.bind((0, _assertThisInitialized2["default"])(_this));
    _this.onCheckoutError = _this.onCheckoutError.bind((0, _assertThisInitialized2["default"])(_this));
    _this.checkCouponDebounced = _lodash["default"].debounce(_this.checkCoupon, 1000);
    return _this;
  }

  (0, _createClass2["default"])(CheckoutForm, [{
    key: "onCouponChanged",
    value: function onCouponChanged(e, _ref) {
      var _this2 = this;

      var value = _ref.value;
      this.setState({
        couponCode: value.trim()
      }, function () {
        _this2.checkCouponDebounced();
      });
    }
  }, {
    key: "onFirstNameChanged",
    value: function onFirstNameChanged(e, _ref2) {
      var _this3 = this;

      var value = _ref2.value;
      this.setState({
        firstName: value
      }, function () {
        _this3.checkInputs();
      });
    }
  }, {
    key: "onLastNameChanged",
    value: function onLastNameChanged(e, _ref3) {
      var _this4 = this;

      var value = _ref3.value;
      this.setState({
        lastName: value
      }, function () {
        _this4.checkInputs();
      });
    }
  }, {
    key: "onAddressChanged",
    value: function onAddressChanged(e, _ref4) {
      var _this5 = this;

      var value = _ref4.value;
      this.setState({
        address: value
      }, function () {
        _this5.checkInputs();
      });
    }
  }, {
    key: "onCityChanged",
    value: function onCityChanged(e, _ref5) {
      var _this6 = this;

      var value = _ref5.value;
      this.setState({
        city: value
      }, function () {
        _this6.checkInputs();
      });
    }
  }, {
    key: "onStateChanged",
    value: function onStateChanged(e, _ref6) {
      var _this7 = this;

      var value = _ref6.value;
      this.setState({
        state: value
      }, function () {
        _this7.checkInputs();
      });
    }
  }, {
    key: "onZipCodeChanged",
    value: function onZipCodeChanged(e, _ref7) {
      var _this8 = this;

      var value = _ref7.value;
      this.setState({
        zipCode: value
      }, function () {
        _this8.checkInputs();
      });
    }
  }, {
    key: "onEmailChanged",
    value: function onEmailChanged(e, _ref8) {
      var _this9 = this;

      var value = _ref8.value;
      this.setState({
        email: value
      }, function () {
        _this9.checkInputs();
      });
    }
  }, {
    key: "onPhoneNumberChanged",
    value: function onPhoneNumberChanged(e, _ref9) {
      var _this10 = this;

      var value = _ref9.value;
      this.setState({
        phoneNumber: value
      }, function () {
        _this10.checkInputs();
      });
    }
  }, {
    key: "onLoadCompleted",
    value: function onLoadCompleted() {
      this.setState({
        checkoutLoading: false
      });
    }
  }, {
    key: "onCheckoutError",
    value: function onCheckoutError() {
      this.setState({
        showErrorMessage: true
      });
      this.onLoadCompleted();
    }
  }, {
    key: "onSubmit",
    value: function () {
      var _onSubmit = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee() {
        var _this11 = this;

        var _this$props, business, currentPlanIndex, isAnnual, stripe, onCheckoutCompleted, currentDomain, customDomain, _this$state, firstName, lastName, address, city, state, zipCode, email, phoneNumber, couponCode, planIndex, stripeCardholderData, _yield$stripe$createT, token, error, url, headers, domainType, data;

        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                this.setState({
                  checkoutLoading: true,
                  error: null
                });
                _this$props = this.props, business = _this$props.business, currentPlanIndex = _this$props.currentPlanIndex, isAnnual = _this$props.isAnnual, stripe = _this$props.stripe, onCheckoutCompleted = _this$props.onCheckoutCompleted, currentDomain = _this$props.currentDomain, customDomain = _this$props.customDomain;
                _this$state = this.state, firstName = _this$state.firstName, lastName = _this$state.lastName, address = _this$state.address, city = _this$state.city, state = _this$state.state, zipCode = _this$state.zipCode, email = _this$state.email, phoneNumber = _this$state.phoneNumber, couponCode = _this$state.couponCode;
                planIndex = isAnnual ? currentPlanIndex * 2 : currentPlanIndex * 2 + 1;
                stripeCardholderData = {
                  name: "".concat(firstName, " ").concat(lastName),
                  address_line1: address,
                  address_city: city,
                  address_state: state,
                  address_zip: zipCode
                };
                _context.next = 7;
                return stripe.createToken(stripeCardholderData);

              case 7:
                _yield$stripe$createT = _context.sent;
                token = _yield$stripe$createT.token;
                error = _yield$stripe$createT.error;
                url = process.env.SERVER_URL || process.env.STORYBOOK_SERVER_URL;
                headers = {
                  'x-api-key': process.env.X_API_KEY || process.env.STORYBOOK_X_API_KEY
                }; // Stripe createToken error handling

                if (!error) {
                  _context.next = 17;
                  break;
                }

                console.error("Error generating token: ", error);
                this.setState({
                  error: error.message
                });
                this.onCheckoutError();
                return _context.abrupt("return");

              case 17:
                domainType = customDomain === null ? 'internal' : 'external';
                data = {
                  stripe_token: token.id,
                  stripe_subscription_plan: _subscriptionPlans["default"][planIndex].id,
                  customer: {
                    firstName: firstName,
                    lastName: lastName,
                    address: address,
                    city: city,
                    state: state,
                    zipCode: zipCode,
                    email: email,
                    phoneNumber: phoneNumber
                  },
                  domain: domainType === 'internal' ? currentDomain.DomainName : customDomain,
                  domainType: domainType
                };
                if (couponCode && couponCode.length > 0) data["coupon"] = couponCode;

                _axios["default"].post("".concat(url, "businesses/").concat(business.type, "s/").concat(business.id, "/subscriptions/"), data, {
                  headers: headers
                }).then(function () {
                  _this11.onLoadCompleted();

                  onCheckoutCompleted();
                })["catch"](function (err) {
                  _this11.onLoadCompleted();

                  if (err) {
                    _this11.onCheckoutError();
                  }
                });

              case 21:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function onSubmit() {
        return _onSubmit.apply(this, arguments);
      }

      return onSubmit;
    }()
  }, {
    key: "checkInputs",
    value: function checkInputs() {
      var _this$state2 = this.state,
          firstName = _this$state2.firstName,
          lastName = _this$state2.lastName,
          address = _this$state2.address,
          city = _this$state2.city,
          state = _this$state2.state,
          zipCode = _this$state2.zipCode,
          email = _this$state2.email,
          phoneNumber = _this$state2.phoneNumber;

      if (firstName && lastName && address && city && state && zipCode && email && phoneNumber) {
        this.setState({
          submitEnabled: true
        });
      }
    }
  }, {
    key: "checkCoupon",
    value: function checkCoupon() {
      var _this12 = this;

      var couponCode = this.state.couponCode;
      var url = process.env.SERVER_URL || process.env.STORYBOOK_SERVER_URL;
      var headers = {
        'x-api-key': process.env.X_API_KEY || process.env.STORYBOOK_X_API_KEY
      };
      var data = {
        code: couponCode
      };

      _axios["default"].post("".concat(url, "businesses/discounts/check/"), data, {
        headers: headers
      }).then(function (res) {
        var data = res.data;

        _this12.setState({
          couponCodeValid: true,
          couponCodeDescription: data.description
        });
      })["catch"](function (err) {
        var data = err.response.data;

        if (data.error) {
          _this12.setState({
            couponCodeValid: false,
            couponCodeDescription: undefined,
            couponCodeError: data.error || "Invalid Coupon"
          });
        }
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          currentPlanIndex = _this$props2.currentPlanIndex,
          isAnnual = _this$props2.isAnnual,
          currentDomain = _this$props2.currentDomain;
      var _this$state3 = this.state,
          submitEnabled = _this$state3.submitEnabled,
          checkoutLoading = _this$state3.checkoutLoading,
          showErrorMessage = _this$state3.showErrorMessage,
          error = _this$state3.error,
          couponCode = _this$state3.couponCode,
          couponCodeValid = _this$state3.couponCodeValid,
          couponCodeDescription = _this$state3.couponCodeDescription,
          couponCodeError = _this$state3.couponCodeError,
          firstName = _this$state3.firstName,
          lastName = _this$state3.lastName,
          address = _this$state3.address,
          city = _this$state3.city,
          state = _this$state3.state,
          zipCode = _this$state3.zipCode,
          email = _this$state3.email,
          phoneNumber = _this$state3.phoneNumber;
      var paymentPlan = _paymentTypes.paymentTypes[currentPlanIndex];
      var totalIfNotAdvanced = isAnnual ? paymentPlan.monthly.price * 12 : paymentPlan.monthly.price;
      var baseTotal = currentPlanIndex < _paymentTypes.CUSTOM_PLAN_INDEX ? totalIfNotAdvanced : null;
      var discount = isAnnual ? paymentPlan.monthly.price * 2 : 0;
      var total = baseTotal - discount;
      var planIndex = isAnnual ? currentPlanIndex * 2 : currentPlanIndex * 2 + 1;
      var plan = _subscriptionPlans["default"][planIndex];
      var planDisplayName = plan.name.split(' - ')[0] + (isAnnual ? ' x 12 months' : ' x 1 month');
      return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Modal.Header, {
        className: "modal-header"
      }, "Checkout"), /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Grid, {
        stackable: true,
        className: "checkout checkout-body"
      }, /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Grid.Row, {
        className: "checkout-payment-heading-row"
      }, /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Grid.Column, {
        computer: 8,
        tablet: 8,
        mobile: 16,
        className: "checkout-border checkout-payment-details",
        id: "checkout-payment-details-firstcol"
      }, /*#__PURE__*/_react["default"].createElement("h3", {
        className: "header-text blue-color"
      }, "Payment Details"), /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Divider, {
        className: "checkout-divider"
      }), /*#__PURE__*/_react["default"].createElement("p", {
        className: "checkout-subheader body-text blue-color"
      }, "Billing Information"), /*#__PURE__*/_react["default"].createElement(_reactStripeElements.CardElement, {
        className: "stripe-checkout-input"
      }), /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Input, {
        value: couponCode,
        id: "coupon-code-input",
        className: "checkout-input",
        placeholder: "Coupon Code",
        onChange: this.onCouponChanged
      }), couponCode && couponCode.length > 0 && !couponCodeValid && /*#__PURE__*/_react["default"].createElement("p", {
        style: {
          color: "red"
        }
      }, "Error: ", couponCodeError), couponCode && couponCodeDescription && /*#__PURE__*/_react["default"].createElement("p", null, "Code unlocked: ", couponCodeDescription), /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Divider, {
        className: "checkout-divider"
      }), /*#__PURE__*/_react["default"].createElement("p", {
        className: "checkout-subheader body-text blue-color"
      }, "Billing Address"), /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Input, {
        value: firstName,
        id: "first-name-input",
        className: "checkout-input check-input-half check-input-half-first",
        placeholder: "First Name",
        onChange: this.onFirstNameChanged
      }), /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Input, {
        value: lastName,
        id: "last-name-input",
        className: "checkout-input check-input-half",
        placeholder: "Last Name",
        onChange: this.onLastNameChanged
      }), /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Input, {
        value: address,
        id: "address-input",
        className: "checkout-input",
        placeholder: "Address",
        onChange: this.onAddressChanged
      }), /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Input, {
        value: city,
        id: "city-input",
        className: "checkout-input check-input-half check-input-half-first",
        placeholder: "City",
        onChange: this.onCityChanged
      }), /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Input, {
        calue: state,
        id: "state-input",
        className: "checkout-input checkout-input-quarter checkout-input-quarter-first",
        placeholder: "State",
        onChange: this.onStateChanged
      }), /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Input, {
        value: zipCode,
        id: "zip-code-input",
        className: "checkout-input checkout-input-quarter",
        placeholder: "Zip Code",
        onChange: this.onZipCodeChanged
      }), /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Input, {
        value: email,
        id: "email-input",
        className: "checkout-input check-input-half check-input-half-first",
        placeholder: "Email",
        onChange: this.onEmailChanged
      }), /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Input, {
        value: phoneNumber,
        id: "phone-number-input",
        className: "checkout-input check-input-half",
        placeholder: "Phone Number",
        onChange: this.onPhoneNumberChanged
      })), /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Grid.Column, {
        computer: 1,
        tablet: 1,
        only: "computer tablet"
      }), /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Grid.Column, {
        computer: 7,
        tablet: 7,
        mobile: 16,
        className: "checkout-border checkout-payment-details"
      }, /*#__PURE__*/_react["default"].createElement("h3", {
        className: "header-text blue-color"
      }, "Order Summary"), /*#__PURE__*/_react["default"].createElement("p", null, "Once you place the order, we\u2019ll connect your website to your selected domain and notify you when the site is live. If you have an existing domain, someone from our team will contact you to connect it."), /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Divider, {
        className: "checkout-divider"
      }), /*#__PURE__*/_react["default"].createElement("div", {
        className: "body-text blue-color checkout-row"
      }, /*#__PURE__*/_react["default"].createElement("p", {
        className: "checkout-row-right"
      }, "$", baseTotal), /*#__PURE__*/_react["default"].createElement("p", null, planDisplayName)), discount !== 0 && /*#__PURE__*/_react["default"].createElement("div", {
        className: "body-text blue-color checkout-row"
      }, /*#__PURE__*/_react["default"].createElement("p", {
        className: "checkout-row-right"
      }, "-$", discount), /*#__PURE__*/_react["default"].createElement("p", null, "Annual plan savings")), currentDomain.DomainName && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
        className: "body-text blue-color checkout-row"
      }, /*#__PURE__*/_react["default"].createElement("p", {
        className: "checkout-row-right strike-through-text"
      }, "$15"), /*#__PURE__*/_react["default"].createElement("p", null, "Domain Service")), /*#__PURE__*/_react["default"].createElement("div", {
        className: "checkout-row checkout-domain-description checkout-row"
      }, /*#__PURE__*/_react["default"].createElement("p", {
        className: "checkout-row-right green-color"
      }, "FREE"), /*#__PURE__*/_react["default"].createElement("p", null, currentDomain.DomainName || /*#__PURE__*/_react["default"].createElement("div", null, "\xA0")))), /*#__PURE__*/_react["default"].createElement("div", {
        className: "blue-color checkout-row"
      }, /*#__PURE__*/_react["default"].createElement("p", {
        className: "checkout-row-right bolded"
      }, "$", total), /*#__PURE__*/_react["default"].createElement("p", {
        className: "checkout-row-leftx bolded"
      }, "Total")), submitEnabled ? /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Button, {
        style: {
          border: '2px solid red !important',
          width: '100%'
        },
        className: "centered-button checkout-button-enabled",
        onClick: this.onSubmit,
        loading: checkoutLoading
      }, "Place Order") : /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Button, {
        className: "centered-button checkout-button-disabled"
      }, "Place Order"), showErrorMessage && /*#__PURE__*/_react["default"].createElement("p", {
        className: "error-message centered-content"
      }, "Error in Processing Payment", error && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, ": ", error, " "))))));
    }
  }]);
  return CheckoutForm;
}(_react["default"].Component);

var _default = (0, _reactStripeElements.injectStripe)(CheckoutForm);

exports["default"] = _default;